(function () {
    'use strict';
    angular.module('app.context', ['rx']);
})();
